import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const Footer = ({ type }: { type?: string }) => {
  const navigate = useNavigate();
  const [emailAlert, setEmailAlert] = useState(false);

  const setCookie = (
    name: string,
    value: string,
    days?: number,
    domain?: string,
  ) => {
    const parts: string[] = [`${name}=${value}`, 'Path=/'];

    if (typeof days === 'number') {
      parts.push(`Max-Age=${days * 24 * 60 * 60}`);
    }

    // localhost/127.0.0.1 에서는 Domain 넣지 말기
    if (domain && domain !== 'localhost' && domain !== '127.0.0.1') {
      parts.push(`Domain=${domain}`);
    }

    document.cookie = parts.join('; ');
  };

  const viewPcVersion = () => {
    if (typeof window === 'undefined') return;

    const { host, pathname, search, hash } = window.location;
    const current = pathname + search + hash;
    const isSearchPage = pathname === '/search';

    const pcSearchPage = type === 'a' ? '/auction/search' : '/pAuction/search';
    const nextUrlPath = isSearchPage ? pcSearchPage : pathname + search + hash;

    const isLocal3000 = host === 'localhost:3000' || host === '127.0.0.1:3000';
    const isDev = host.includes('dev.') || isLocal3000;

    // if (isLocal3000) {
    //   setCookie('forcePc', '1', 1); // host-only cookie
    //   window.location.href = 'http://localhost:3001' + current;
    //   return;
    // }

    // dev.m ↔ dev., prod 포함 전체 공유
    setCookie('forcePc', '1', isDev ? 30 : 365, '.zipgoai.com');
    window.location.href =
      (isDev ? 'https://dev.zipgoai.com' : 'https://zipgoai.com') + nextUrlPath;
  };

  return (
    <Container>
      <PCButton onClick={viewPcVersion}>
        <img src="/assets/images/icon/desktop.svg" alt="pc" />
        PC 버전으로 보기
      </PCButton>
      <Content>
        <InquireContainer>
          <InquireNumber>고객센터</InquireNumber>
          <InquireNumber>
            <img src="/assets/images/icon/call-black.svg" alt="call" />
            02-555-2822
          </InquireNumber>
          <InquireDescription>
            평일 09:30~19:30, 주말 10:00~15:00
          </InquireDescription>
        </InquireContainer>
        <Email>
          <img src="/assets/images/icon/mail.svg" alt="mail" />
          biz@transfarmer.co.kr
        </Email>
      </Content>
      <Divider />
      <PageButtonWrapper>
        <PageButton
          onClick={() => {
            navigate('/companyinfo');
          }}
        >
          회사소개
        </PageButton>
        <PageButtonSeparator />
        <PageButton
          onClick={() => {
            navigate('/terms/service');
          }}
        >
          이용약관
        </PageButton>
        <PageButtonSeparator />
        <PageButton
          onClick={() => {
            navigate('/terms/location');
          }}
        >
          위치기반서비스 이용약관
        </PageButton>
        <PageButtonSeparator />
        <PageButton
          onClick={() => {
            navigate('/terms/privacy');
          }}
        >
          개인정보 취급방침
        </PageButton>
        <PageButtonSeparator />
        <PageButton
          onClick={() => {
            setEmailAlert(true);
          }}
        >
          이메일 무단수집거부
        </PageButton>
      </PageButtonWrapper>
      <img src="/assets/images/logo/zipgoai_logo_mobile_header.svg" alt="" />
      <Inner>
        <Content>
          <Info>
            제호 : 땅집고
            <InfoSeparator />
            상호 : (주)엠딕
            <InfoSeparator />
            대표 : 유하용
          </Info>
          <Info>사업자등록번호 : 47888-01-291</Info>
          <Info>주소 : 서울특별시 중구 세종대로 21길 22, 2층</Info>
          <Info>
            제호 : 땅집고옥션
            <InfoSeparator />
            상호 : 트랜스파머(주)
            <InfoSeparator />
            대표 : 김기현
          </Info>
          <Info>사업자등록번호 : 507-87-02631</Info>
          <Info>주소 : (본점)강원특별자치도 춘천시 춘천로 188, 210-C75호</Info>
          <Info>
            (기업부설연구소)서울 마포구 백범로31길 21, 서울창업허브별관 108호
            트랜스파머
          </Info>
          <Info>
            대표전화 : 02)555-2822 (평일 09:30~19:30, 주말 10:00~15:00)
            <InfoSeparator />
            E-mail : biz@transfarmer.co.kr
            <InfoSeparator />
            개인정보보호책임자 : 박성필
          </Info>
        </Content>
        <Info>
          (주)엠딕과 트랜스파머(주)는 땅집고옥션 서비스의 공동사업자로
          트랜스파머(주)는 해당 홈페이지 운영을 담당하고 있습니다.
        </Info>
        <Info>COPYRIGHTⓒ 땅집고옥션, ALL RIGHT RESERVED.</Info>
      </Inner>

      {emailAlert && (
        <EmailContainer
          onClick={(e) => {
            e.stopPropagation(); // 이벤트 전파 방지
            setEmailAlert(false);
          }}
        >
          <EmailBox
            onClick={(e) => {
              e.stopPropagation(); // 이벤트 전파 방지
            }}
          >
            <EmailInner>
              <div>
                <span>이메일 무단수집 금지 안내</span>
              </div>
              <div>
                당사 웹사이트(https://zipgoai.com/)에 게시된 이메일주소를
                무단으로 수집하는 것을 금지합니다. 이메일주소 수집 프로그램 또는
                기타 기술적 장치를 통해 무단으로 이메일주소를 수집할 경우,
                정보통신망이용촉진 및 정보보호 등에 관한 법률 제50조의2,
                제65조의2에 의거하여 1천만원 이하의 벌금형이 부과될 수 있음을
                알려드립니다.
              </div>
            </EmailInner>
            <ButtonBox
              onClick={(e) => {
                setEmailAlert(false);
              }}
            >
              확인
            </ButtonBox>
          </EmailBox>
        </EmailContainer>
      )}
    </Container>
  );
};
export default Footer;

const Container = styled.div`
  display: flex;
  padding: 30px 16px 120px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  border-top: 1px solid #e5e8ea;
  background: #f9fafb;
`;

const PCButton = styled.div`
  display: flex;
  padding: 12px 14px;
  justify-content: center;
  align-items: center;
  gap: 5px;
  align-self: stretch;
  border-radius: 8px;
  background: rgba(2, 32, 71, 0.05);

  color: rgba(0, 12, 30, 0.8);
  font-size: 14px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.28px;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

const InquireContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  align-self: stretch;
`;

const InquireNumber = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  color: #2a3038;
  font-size: 18px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.36px;
`;

const InquireDescription = styled.div`
  color: #6b7684;
  font-size: 12px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.24px;
`;

const Email = styled.div`
  display: flex;
  align-items: center;
  align-content: center;
  gap: 8px;
  align-self: stretch;

  color: #6b7684;
  font-size: 13px;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.26px;
`;

const Divider = styled.div`
  height: 1px;
  align-self: stretch;
  background: #e5e8ea;
`;

const PageButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  align-content: center;
  gap: 0 12px;
  align-self: stretch;
  flex-wrap: wrap;
`;

const PageButton = styled.div`
  color: #2a3038;
  font-size: 13px;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: -0.26px;
`;
const PageButtonSeparator = styled.div`
  width: 1px;
  height: 8px;
  background: #2a3038;
`;

const Inner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`;

const Info = styled.div`
  display: flex;
  align-items: center;
  align-content: center;
  gap: 8px;
  align-self: stretch;
  flex-wrap: wrap;

  color: #6b7684;
  font-size: 13px;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.26px;
`;

const InfoSeparator = styled.div`
  width: 1px;
  height: 8px;
  background: #6b7684;
`;

const EmailContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.52);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
`;

const EmailBox = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #ffffff;
  padding: 24px;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;

  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 24px;
  z-index: 100;
`;

const EmailInner = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 6px;
  width: 100%;

  color: #616161;
  font-size: 16px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  line-height: 23.2px;
  word-wrap: break-word;

  span {
    color: #222222;
    font-size: 18px;
    font-family: Spoqa Han Sans Neo;
    font-weight: 700;
    line-height: 26.1px;
    word-wrap: break-word;
  }
`;

const ButtonBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 28px;
  background-color: #008aff;
  border-radius: 8px;
  color: white;
  font-size: 16px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  line-height: 26.4px;
  word-wrap: break-word;
  cursor: pointer;
`;
